import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 公司信息 */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                className="h-8 w-auto"
                src="/images/logo-clean.png"
                alt="艾尔达环保"
              />
              <span className="ml-2 text-xl font-bold">艾尔达环保</span>
            </div>
            <p className="text-secondary-300 mb-4">
              河南艾尔达环保科技有限公司专注于LDAR泄漏检测与修复技术，
              为石化、化工、制药等行业提供专业的环保技术服务。
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-secondary-300">
                <Phone className="h-4 w-4 mr-2" />
                <span>0371-67116867</span>
              </div>
              <div className="flex items-center text-secondary-300">
                <Mail className="h-4 w-4 mr-2" />
                <span>李经理 15515625935</span>
              </div>
              <div className="flex items-center text-secondary-300">
                <MapPin className="h-4 w-4 mr-2" />
                <span>河南省郑州市二七区马寨镇工业路11号院6号楼2楼</span>
              </div>
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-white transition-colors">
                  公司简介
                </Link>
              </li>
              <li>
                <Link to="/qualifications" className="text-secondary-300 hover:text-white transition-colors">
                  资质能力
                </Link>
              </li>
              {/* <li>
                <Link to="/cases" className="text-secondary-300 hover:text-white transition-colors">
                  工程案例
                </Link>
              </li>*/}
              <li>
                <Link to="https://ecp.ldar100.cn" className="text-secondary-300 hover:text-white transition-colors">
                  检测平台
                </Link>
              </li> 
              <li>
                <Link to="/disclosure" className="text-secondary-300 hover:text-white transition-colors">
                  信息公示
                </Link>
              </li>
              {/* <li>
                <Link to="/careers" className="text-secondary-300 hover:text-white transition-colors">
                  人才招聘
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="text-secondary-300 hover:text-white transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          {/* 服务项目 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">服务项目</h3>
            <ul className="space-y-2">
              <li className="text-secondary-300">LDAR检测服务</li>
              <li className="text-secondary-300">VOCs治理</li>
              <li className="text-secondary-300">环保咨询</li>
              <li className="text-secondary-300">技术培训</li>
              {/* <li className="text-secondary-300">设备销售</li> */}
            </ul>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="border-t border-secondary-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-secondary-400 text-sm">
              © {currentYear} 河南艾尔达环保科技有限公司. 保留所有权利.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="#" className="text-secondary-400 hover:text-white text-sm">
                隐私政策
              </a>
              <a href="#" className="text-secondary-400 hover:text-white text-sm">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
} 